import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import * as SiteStories from '../Site.stories';
import SiteDetailPageTabs from './SiteDetailPageTabs';
import { onDragEnd } from '../../../utils/dragDrop';

export default {
  title: 'Components/SiteDetailPageTabs',
  component: SiteDetailPageTabs,
  parameters: {
    layout: 'fullscreen',
  },
  tags: ['autodocs'],
};
// Base Template function for stories
const SiteDetailPageTemplate = ({
  tabsData,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (tabsData) {
      setItems(tabsData);
    }
  }, [tabsData]);

  if (!items) {
    return null;
  }
  const storyBookOnDragEnd = (result) => {
    onDragEnd(result, items, setItems);
  };
  return (
    <SiteDetailPageTabs
      tabsData={items}
      onDragEnd={storyBookOnDragEnd}
    />
  );
};
SiteDetailPageTemplate.propTypes = {
  tabsData: PropTypes.array.isRequired,
};

// Binding the base template
const Template = SiteDetailPageTemplate.bind({});

// create data for Tabs from Site stories
export const Default = Template.bind({});
Default.args = {
  tabsData: [
    {
      title: 'Visits',
      data: SiteStories.Default.args.siteData.visits,
      onClick: () => { },
      length: SiteStories.Default.args.siteData.visits.length,
    },
    {
      title: 'Notes',
      data: SiteStories.Default.args.siteData.notes,
      onClick: () => { },
      length: SiteStories.Default.args.siteData.notes.length,
    },
    {
      title: 'Contacts',
      data: SiteStories.Default.args.siteData.contacts,
      onClick: () => { },
      length: SiteStories.Default.args.siteData.contacts.length,
    },
    {
      title: 'Site History',
      data: SiteStories.Default.args.siteData.site_histories.paginated_histories,
    },
    {
      title: 'Contact History',
      data: SiteStories.Default.args.siteData.contact_histories.paginated_histories,
    },
  ],
};

export const TabsWithData = Template.bind({});
TabsWithData.args = {
  tabsData: [
    {
      title: 'Visits',
      data: SiteStories.SiteWithData.args.siteData.visits,
      onClick: () => { },
      length: SiteStories.SiteWithData.args.siteData.visits.length,
    },
    {
      title: 'Notes',
      data: SiteStories.SiteWithData.args.siteData.notes,
      onClick: () => { },
      length: SiteStories.SiteWithData.args.siteData.notes.length,
    },
    {
      title: 'Contacts',
      data: SiteStories.SiteWithData.args.siteData.contacts,
      onClick: () => { },
      length: SiteStories.SiteWithData.args.siteData.contacts.length,
    },
    {
      title: 'Site History',
      data: SiteStories.SiteWithData.args.siteData.site_histories,
    },
    {
      title: 'Contact History',
      data: SiteStories.SiteWithData.args.siteData.contact_histories,
    },
  ],
};

